var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 48,
  width: 48
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.7 5V1.7h12.6V5Zm4.65 22.6h3.3V16.1h-3.3ZM24 44.5q-3.8 0-7.125-1.45t-5.8-3.925Q8.6 36.65 7.15 33.325 5.7 30 5.7 26.2q0-3.75 1.45-7.1 1.45-3.35 3.925-5.825 2.475-2.475 5.8-3.925Q20.2 7.9 24 7.9q3.35 0 6.35 1.125 3 1.125 5.3 3.125L38.3 9.5l2.3 2.3-2.65 2.65q1.8 2.05 3.075 4.925Q42.3 22.25 42.3 26.2q0 3.8-1.45 7.125t-3.925 5.8Q34.45 41.6 31.1 43.05 27.75 44.5 24 44.5Zm0-3.4q6.2 0 10.55-4.35Q38.9 32.4 38.9 26.2q0-6.2-4.35-10.55Q30.2 11.3 24 11.3q-6.2 0-10.55 4.35Q9.1 20 9.1 26.2q0 6.2 4.35 10.55Q17.8 41.1 24 41.1Zm0-14.85Z"
})));

export default SvgTimer;